import { useCurrentClient } from '@pbk-web/state';
import { hasPermission } from '@pbk-web/utils';
import { useCallback } from 'react';

import { useCurrentUser } from '../../global-state/Auth';

export { hasPermission };

const usePermissions = () => {
  const currentUser = useCurrentUser((x) => x.value);
  const currentClient = useCurrentClient((x) => x.value);

  return useCallback(
    (permissions: string | string[], clientIdOverride?: string) => {
      return hasPermission(clientIdOverride ?? currentClient?.id, currentUser, permissions);
    },
    [currentClient?.id, currentUser],
  );
};

export default usePermissions;
